import type { Catalog } from "../../en";

export const playground: Catalog["build"]["playground"] = {
  title: "Playground",
  config: {
    title: "Configuration",
    sheetTitle: "Settings ng Playground",
    open: "Configuration",
    unsaved: "Hindi naka-save",
    unsavedHint: "I-save sa agent para masubukan ang mga pagbabagong ito — ang naka-save na settings ng agent ang ginagamit ng mga test na sagot.",
    model: "Model",
    modelOption: "{{name}} · {{descriptor}}",
    creditsHint_one: "Gumagamit ng {{count}} message credit kada sagot.",
    creditsHint_other: "Gumagamit ng {{count}} message credits kada sagot.",
    temperature: "Temperature",
    precise: "Eksakto",
    creative: "Malikhain",
    strict: "Sumagot lang mula sa knowledge",
    strictHint: "Kung walang makitang source, sabihin ito at mag-alok ng handoff — huwag manghula.",
    citation: "Estilo ng citation",
    citations: { numbered: "Inline [1]", source_names: "Mga source sa ibaba", hidden: "Off" },
    audience: "I-simulate ang audience",
    audienceHint: "Binabago ng access filtering ang retrieval: inaalis ang mga chunk na hindi makikita ng audience bago mag-ranking.",
    audienceEffective: "Nababasa ng audience na iyon sa agent na ito: {{labels}}",
    audienceClosed: "Sarado ang agent na ito sa audience na iyon (limitado ng “Sino ang puwedeng makipag-chat”), kaya tinatanggihan nito ang mga mensahe nila. Pumili ng ibang audience para masubukan ito.",
    language: "Wika ng sagot",
    languages: { match: "Sundan ang user", english: "Laging English" },
    instructions: "System instructions",
    tokens: "≈ {{count}} tokens",
    reset: "I-reset",
    resetDone: "Naibalik ang configuration sa naka-save na settings ng agent",
    save: "I-save sa agent",
    saved: "Na-save sa {{name}} — live sa lahat ng channel sa loob ng isang minuto",
  },
  chat: {
    subtitle: "{{model}} · {{audience}} · {{count}} sources",
    defaultModel: "Default na model",
    badge: "Playground — hindi nakikita ng users",
    showTrace: "Ipakita ang trace",
    clear: "I-clear ang chat",
    cleared: "Nagsimula ang bagong test na usapan",
    audienceClosedError: "Sarado ang agent na ito sa “{{audience}}” (limitado ng “Sino ang puwedeng makipag-chat”). Pumili ng ibang audience sa I-simulate ang audience para masubukan ito.",
    starters: "Mga mungkahing tanong",
    welcomeBody: "Itanong ang kahit anong itatanong ng mga taong pinagsisilbihan mo. Ipinapakita ng trace panel kung aling mga dokumento ang hinanap at bakit. Walang nase-save sa Inbox.",
    placeholder: "Magtanong ng test… (Enter para ipadala, Shift+Enter para sa bagong linya)",
    footer: "Gumagamit ng test credits ang mga mensahe sa Playground at hindi kasama sa Analytics.",
    log: "Test na usapan",
    stop: "Itigil",
    retry: "Subukan muli",
    planTitle: "Playground credits",
  },
  stages: {
    understanding: "Binabasa ang tanong…",
    retrieving: "Hinahanap sa iyong knowledge…",
    reranking: "Sinusuri ang pinakamahusay na source…",
    generating: "Isinusulat ang sagot…",
    validating: "Sinusuring muli ang sagot…",
  },
  trace: {
    title: "Retrieval trace",
    sheetTitle: "Debug",
    tabs: { trace: "Trace", sources: "Mga source na ginamit", json: "Raw JSON" },
    status: { idle: "Idle", running: "Tumatakbo", grounded: "Grounded", fallback: "Fallback", error: "Hindi available" },
    emptyTitle: "Wala pang trace",
    emptyBody: "Magpadala ng tanong para makita ang binagong query, aling mga chunk ang nakuha at bakit, latency kada yugto, at gastos sa token.",
    noSources: "Wala pang source",
    nothing: "Walang maipapakita",
    loadError: "Hindi ma-load ang trace.",
    running: "Hinihintay matapos ang sagot…",
    query: "Query",
    asked: "Tinanong ng user",
    rewritten: "Binago para sa paghahanap",
    notRewritten: "Ginamit kung paano itinanong",
    language: "Wika: {{language}}",
    latency: "Latency",
    total: "{{value}} kabuuan",
    legendRetrieval: "Retrieval",
    legendFirst: "Oras bago ang unang token",
    legendGeneration: "Generation",
    access: "Access filter",
    accessBody: "Hinanap lang ang mga source na nakikita ng: {{audiences}}. Inalis bago mag-ranking ang mga chunk na para sa ibang audience.",
    cache: "Cache: {{kind}}",
    cacheMiss: "Walang cache hit",
    chunks: "Mga nakuhang kandidato",
    chunkCounts: "{{used}} ginamit · {{filtered}} hindi ginamit",
    used: "Ginamit sa sagot",
    filtered: "Hindi ginamit",
    ranks: { dense: "vector", lexical: "keyword", question: "tanong", fuzzy: "fuzzy", rrf: "RRF", rerank: "rerank" },
    rank: "#{{value}}",
    untitled: "Source na walang pamagat",
    openSource: "Buksan ang source",
    noChunks: "Walang nakuhang kandidato para sa tanong na ito.",
    tokens: "Tokens at gastos",
    input: "Input",
    output: "Output",
    cost: "Tantyang gastos",
    model: "Model",
    embedding: "Embedding",
    reranker: "Reranker",
    search: "Paghahanap",
    grounding: "Grounding",
    grounded: "Grounded",
    notGrounded: "Hindi grounded",
    confidence: "kumpiyansa {{value}}",
    groundedBody: "Bawat pahayag sa sagot ay tumutugma sa isang naka-cite na chunk.",
    ungroundedBody: "Walang chunk na lumampas sa threshold, kaya tumanggi ang agent at nag-alok ng handoff. Naitala ang tanong sa Knowledge Gaps.",
    gapsLink: "Knowledge Gaps",
    noSourcesTitle: "Walang source na ginamit",
    noSourcesBody: "Walang nakitang may kaugnayan ang agent kaya tumanggi itong sumagot. Magdagdag ng Q&A o dokumento para punan ito.",
    answerGap: "Sagutin ang gap na ito",
    copy: "Kopyahin",
    copied: "Nakopya",
    endpoint: "GET /v1/messages/{{id}}/trace",
  },
};
